module.exports = __webpack_public_path__ + "images/autoexpert_small41bcfe459adf174ffa7537231483d86e.png";